import { TEXT_GENERATION } from '../../constants/CopilotInAppActionTypes';
// TODO: This is a temporary fix to unblock the collab mode. Valid values are 'paragraph', 'conclusion', and 'outline'. Defaulting to 'paragraph' as that is the broadest value.
const CONTENT_TYPE_PARAGRAPH = 'paragraph';
export const convertTextGenerationAction = inAppActionLegacy => {
  return {
    name: TEXT_GENERATION,
    arguments: {
      '@type': 'map',
      value: {
        contentType: {
          '@type': 'string',
          value: CONTENT_TYPE_PARAGRAPH // TODO: This is a temporary fix to unblock the collab mode. This should be removed as a required field in the backend.
        },
        topic: {
          '@type': 'string',
          value: inAppActionLegacy.prompt
        },
        brandVoiceChannel: {
          '@type': 'string',
          value: inAppActionLegacy.brandVoiceChannel || ''
        },
        brandVoiceSubChannel: {
          '@type': 'string',
          value: inAppActionLegacy.brandVoiceSubChannel || ''
        },
        businessUnitId: {
          '@type': 'integer',
          value: inAppActionLegacy.businessUnitId || 0
        },
        language: {
          '@type': 'string',
          value: inAppActionLegacy.contentLanguage || ''
        },
        context: {
          '@type': 'string',
          value: inAppActionLegacy.context || ''
        },
        editorText: {
          '@type': 'string',
          value: inAppActionLegacy.editorText || ''
        },
        followingText: {
          '@type': 'string',
          value: inAppActionLegacy.followingText || ''
        },
        fromEmail: {
          '@type': 'string',
          value: inAppActionLegacy.fromEmail || ''
        },
        precedingText: {
          '@type': 'string',
          value: inAppActionLegacy.precedingText || ''
        },
        recipientCompany: {
          '@type': 'string',
          value: inAppActionLegacy.recipientCompany || ''
        },
        recipientLocation: {
          '@type': 'string',
          value: inAppActionLegacy.recipientLocation || ''
        },
        recipientRole: {
          '@type': 'string',
          value: inAppActionLegacy.recipientRole || ''
        },
        slug: {
          '@type': 'string',
          value: inAppActionLegacy.slug || ''
        },
        title: {
          '@type': 'string',
          value: inAppActionLegacy.title || ''
        },
        toEmail: {
          '@type': 'string',
          value: inAppActionLegacy.toEmail || ''
        },
        type: {
          '@type': 'string',
          value: inAppActionLegacy.type || ''
        }
      }
    }
  };
};